import ButtonExtension from './button-extension/src/button-extension.js';


if (!BEditor.ExtensionsManager)
{
  BEditor.ExtensionsManager = new ExtensionsManager();
}


export default function ExtensionsManager ()
{
  const pThis = this;

  pThis.createButtonExtension = createButtonExtension;
  pThis.initButtonsExtensions = initButtonsExtensions;
  pThis.getObjectById = getObjectById;
  pThis.objects = [];

  function createButtonExtension(extId, pButton)
  {
    let i;

    for (i = 0; i < pThis.objects.length; i++)
    {
      if (pThis.objects[i].id === extId)
      {
        return pThis.objects[i].pObject;
      }
    }

    i = pThis.objects.length;
    pThis.objects[i] = {};
    pThis.objects[i].id = extId;
    pThis.objects[i].pObject = new ButtonExtension(extId, pButton);

    return (pThis.objects[i].pObject.getIsExists() ? pThis.objects[i].pObject : null);
  }

  function initButtonsExtensions(extParameters)
  {
    let button;

    for (let k in extParameters.ExpandButtons)
    {
      if (extParameters.ExpandButtons.hasOwnProperty(k))
      {
        initButton(k, extParameters);
      }
    }
  }

  function initButton(key, extParameters)
  {
    const button = getObjectById(key);

    if (button)
    {
      button.init(extParameters.ExpandButtons[key], extParameters);
    }
    else
    {
      setTimeout(() => initButton(key, extParameters), 100);
    }
  }

  function getObjectById(id)
  {
    for (let i = 0; i < pThis.objects.length; i++)
    {
      if (pThis.objects[i].id === id)
      {
        return pThis.objects[i].pObject;
      }
    }

    return null;
  }

}
